import { render, staticRenderFns } from "./PicInputVueComponent.vue?vue&type=template&id=c7aed2d4&scoped=true&"
import script from "./PicInputVueComponent.vue?vue&type=script&lang=ts&"
export * from "./PicInputVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PicInputVueComponent.vue?vue&type=style&index=0&id=c7aed2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aed2d4",
  null
  
)

export default component.exports